import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import * as UTIL from "../../util";
import { DesktopTitleCardList } from "../card";
import Wrapper from '../wrapper/Wrapper';
import { promoImpressionsRV } from './../../util/ga-analytics/ecomm/checkout';
export var RetailRecentlyViewed = function RetailRecentlyViewed(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      _props$layout = props.layout,
      proplayout = _props$layout === void 0 ? {} : _props$layout,
      _props$recentlyViewed = props.recentlyViewed,
      products = _props$recentlyViewed === void 0 ? [] : _props$recentlyViewed,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? true : _props$isPromoProduct;
  var _fields$items = fields.items,
      items = _fields$items === void 0 ? {} : _fields$items;
  var background = items.background,
      padding = items.padding;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasLoadedOnce = _useState2[0],
      setHasLoadedOnce = _useState2[1]; // conditional for promo products, hasLoadedOnce to prevent duplicate info appearing in gtm/ga


  if ((products === null || products === void 0 ? void 0 : products.length) > 0 && !hasLoadedOnce) {
    promoImpressionsRV(products);
  }

  var cardModel = function cardModel(product) {
    return {
      "image": {
        "value": {
          "src": product.imgUrl,
          "alt": product.imgAlt,
          "title": product.imgAlt
        }
      },
      "link1": {
        "value": {
          "text": "",
          "title": "",
          "href": product.href,
          "class": ""
        }
      },
      cardColor: {
        fields: {
          value: "color5"
        }
      }
    };
  };

  var cards = Array.isArray(products) ? products.map(function (product) {
    return {
      fields: cardModel(product)
    };
  }) : [];

  var layout = _objectSpread({
    background: background || 'solid',
    padding: padding || 'medium'
  }, proplayout);

  useEffect(function () {
    if (!hasLoadedOnce) {
      setHasLoadedOnce(true);
    }
  }, []);
  return Array.isArray(products) && Boolean(products.length) && /*#__PURE__*/React.createElement("div", {
    className: "cb-retail__recently-viewed"
  }, /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(DesktopTitleCardList, {
    title: {
      value: "Recently Viewed"
    },
    layout: layout,
    cards: cards,
    cardDisplayType: "carousel",
    totalCardsInRow: "5",
    showArrows: true,
    isPromoProduct: isPromoProduct
  })));
};